import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UnitInfo } from '@cue/navigation-services';
import { NgTemplateOutlet } from '@angular/common';
import { ExpansionPanelComponent } from '@progress/kendo-angular-layout';
import { UnitDetailComponent } from '@cue/navigation-widgets';

@Component({
  selector: 'assist-multiview-device',
  imports: [NgTemplateOutlet, ExpansionPanelComponent, UnitDetailComponent],
  templateUrl: './multiview-device.component.html',
  styleUrl: './multiview-device.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiviewDeviceComponent {
  unitInfos = input.required<UnitInfo[]>();
  loading = input.required<boolean>();
}
